import { Grid, styled, SxProps } from "@mui/material";
import { Button } from "@volt_developers/components";

import type { ReactNode } from "react";

export interface IconButtonOnHoverProps {
  canBeVisible: boolean;
  children: ReactNode;
  icon: ReactNode;
  onClick(): void;
  buttonTestId?: string;
  "data-testid"?: string;
  sx?: SxProps;
}

export function IconButtonOnHover({
  children,
  canBeVisible,
  "data-testid": dataTestId,
  onClick,
  icon,
  buttonTestId,
  sx,
}: IconButtonOnHoverProps) {
  return (
    <StyledGrid data-testid={dataTestId} sx={sx} container>
      <Grid xs={11} item>
        {children}
      </Grid>
      <Grid xs={1} item>
        {canBeVisible && (
          <StyledIconButton
            data-testid={buttonTestId}
            variant="text"
            onClick={onClick}
          >
            {icon}
          </StyledIconButton>
        )}
      </Grid>
    </StyledGrid>
  );
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(1),

  [`& ${StyledIconButton}`]: {
    visibility: "hidden",
  },

  [`&:hover ${StyledIconButton}`]: {
    visibility: "visible",
  },
}));

const StyledIconButton = styled(Button)({
  "& > div": {
    display: "flex",
    alignItems: "center",
  },
});
